import { useTranslation } from 'react-i18next'

import Button, { BUTTON_HEIGHT_32 } from '../../../../../../../Button'
import { ICON_HEIGHT_16 } from '../../../../../../../Icon'
import {
  ButtonSelect,
  ButtonTextSelectControl,
} from '../../../../../../../Select'
import { QA_NAME_MATCH_RULES_ADD_CRITERION } from '../../ListingProfileApplicantsMatchRules.constants'

import { getMatchRulesAddCriterionOptions } from './ListingProfileApplicantsMatchRulesModalAddCriterion.utils'

import * as styles from './ListingProfileApplicantsMatchRulesModalAddCriterion.module.css'

import PlusIcon from '../../../../../../../../icons/plus.svg'

function ListingProfileApplicantsMatchRulesModalAddCriterion({
  isReadOnly,
  options,
  onAdd,
}) {
  const { t } = useTranslation()

  const isEmpty = options.length === 0

  function handleSelectItem({ value }) {
    onAdd(options.find(option => option.key === value))
  }

  return (
    <ButtonSelect
      Control={ButtonTextSelectControl}
      className={styles.ListingProfileApplicantsMatchRulesModalAddCriterion}
      controlProps={{
        buttonProps: {
          Button: Button.Flat,
          beforeIconProps: { Icon: PlusIcon, height: ICON_HEIGHT_16 },
          disabled: isReadOnly || isEmpty,
          height: BUTTON_HEIGHT_32,
          iconProps: { height: ICON_HEIGHT_16 },
          qaName: QA_NAME_MATCH_RULES_ADD_CRITERION,
          text: t('RentalPortal.MatchRulesAddCriterionBtnKey'),
          tooltip: isEmpty
            ? t('RentalPortal.MatchRulesAddCriterionEmptyKey')
            : undefined,
        },
      }}
      disabled={isReadOnly || isEmpty}
      dropdownFloatingConfig={{ maxWidthByRef: false }}
      dropdownProps={{ className: styles.dropdown }}
      listProps={{ headerProps: { Search: null } }}
      options={getMatchRulesAddCriterionOptions({ options, t })}
      onSelectItem={handleSelectItem}
    />
  )
}

export default ListingProfileApplicantsMatchRulesModalAddCriterion
